import { useEffect, useState } from 'react';

/**
 * The clock "today" is judged against, in the browser's timezone. Ticks on its
 * own so a board left open past midnight turns stale even when refetches fail.
 */
export function useMinuteClock(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(id);
  }, []);
  return now;
}
